import React, { useEffect, useState } from "react";
import { Box, Grid, Input, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import { Formik } from "formik";
import { ArrowRightAltOutlined } from "@mui/icons-material";
import {
  createPublish,
  updatePublish,
} from "app/services/publishServices/Publish";
import { MatxLoading } from "app/components";
import SnackbarProvider from "app/components/SnackbarProvider";
import { notify } from "app/utils/notifyUtils";

const validationSchema = Yup.object().shape({
  authors: Yup.string().required("Autores é um campo obrigatório"),
  title: Yup.string().required("Título é um campo obrigatório"),
  journal: Yup.string().required("Journal/Periódico é um campo obrigatório"),
  year: Yup.number()
    .required("Ano é um campo obrigatório")
    .typeError("Ano deve ser um número"),
  doi: Yup.string().required("DOI é um campo obrigatório"),
});
interface FormPublishProps {
  data?: any;
  setNewPublish?: any;
}

const FormPublish: React.FC<FormPublishProps> = ({ data, setNewPublish }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const snackbarProvider = SnackbarProvider();
  const [initialValues, setInitialValues] = useState({
    id: "",
    authors: "",
    title: "",
    journal: "",
    year: "",
    doi: "",
  });

  const handleFormSubmit = async (values) => {
    setFormLoading(true);
    try {
      values.id ? await updatePublish(values) : await createPublish(values);
      notify("success", "Dados enviados com sucesso!");
    } catch (error) {
      notify("error", "Erro ao enviar dados. Tente novamente.");
    } finally {
      setFormLoading(false);
      setNewPublish(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const loadPublishData = async () => {
      const publishData = data;
      if (publishData) {
        setInitialValues({
          id: publishData.id,
          authors: publishData.authors,
          title: publishData.title,
          journal: publishData.journal,
          year: publishData.year,
          doi: publishData.doi,
        });
      }
      setLoading(false);
    };
    loadPublishData();
  }, [data]);

  if (loading) {
    return (
      <div style={{ height: "10vh" }}>
        <MatxLoading />
      </div>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        width: "100%",
        mx: "auto",
      }}
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Input type="hidden" value={values.id} />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="title"
                  label="Título"
                  variant="outlined"
                  margin="none"
                  onBlur={handleBlur}
                  value={values.title}
                  onChange={handleChange}
                  helperText={touched.title && errors.title}
                  error={Boolean(errors.title && touched.title)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="authors"
                  label="Autores"
                  variant="outlined"
                  margin="none"
                  onBlur={handleBlur}
                  value={values.authors}
                  onChange={handleChange}
                  helperText={touched.authors && errors.authors}
                  error={Boolean(errors.authors && touched.authors)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="journal"
                  label="Journal/Periódico"
                  variant="outlined"
                  margin="none"
                  onBlur={handleBlur}
                  value={values.journal}
                  onChange={handleChange}
                  helperText={touched.journal && errors.journal}
                  error={Boolean(errors.journal && touched.journal)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="year"
                  label="Ano"
                  variant="outlined"
                  margin="none"
                  onBlur={handleBlur}
                  value={values.year}
                  onChange={handleChange}
                  helperText={touched.year && errors.year}
                  error={Boolean(errors.year && touched.year)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="doi"
                  label="DOI"
                  variant="outlined"
                  margin="none"
                  onBlur={handleBlur}
                  value={values.doi}
                  onChange={handleChange}
                  helperText={touched.doi && errors.doi}
                  error={Boolean(errors.doi && touched.doi)}
                />
              </Grid>

              <Grid item xs={6}>
                <LoadingButton
                  type="submit"
                  color="primary"
                  loading={formLoading}
                  variant="contained"
                  endIcon={<ArrowRightAltOutlined fontSize="small" />}
                >
                  Cadastrar
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default FormPublish;
